import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { filingMachine } from './filing.machine';

export const useFilingRef = () => feature('filing');
export const useFiling = <R>(selector: (snapshot: SnapshotFrom<typeof filingMachine>) => R) =>
  useFeature('filing', selector);
export const useFilingActions = () => {
  const ref = useFilingRef();
  return {
    loadFilings: () => ref.send({ type: 'filing.load-filings' }),
    loadReview: (filingId: string) => ref.send({ type: 'filing.load-review', filingId }),
    correct: (filingId: string, correctionNote: string) =>
      ref.send({ type: 'filing.correct', filingId, correctionNote }),
    correctRejected: (filingId: string, correctionNote: string) =>
      ref.send({ type: 'filing.correct-rejected', filingId, correctionNote }),
    open: (clientId: string, taxRuleSetId: string, filingCredentialId: string) =>
      ref.send({ type: 'filing.open', clientId, taxRuleSetId, filingCredentialId }),
  };
};
